import { UrlSegment } from '@angular/router';
import { isEpiserverFactory } from './state/app-config/factories/is-episerver.factory';

export class CultureMatcher {
    private isEpiserver: boolean;

    constructor(document: Document) {
        this.isEpiserver = isEpiserverFactory(document);
    }

    matcher = (url: UrlSegment[]) => {
        if (
            !this.isEpiserver &&
            url.length &&
            url[0] &&
            this.isCountryOrLanguage(url[0].path)
        ) {
            const consumed = [url[0]];
            const posParams = { countryCode: url[0] };
            return { consumed, posParams };
        }

        return { consumed: [] };
    };

    private isCountryOrLanguage(code: string) {
        return /^[a-z]{2}(-[a-z]{2})?$/i.test(code);
    }
}

export const CustomCultureMatcher = new CultureMatcher(document);
